import React, { useContext, useEffect, useState } from 'react';
import Icon, { CloseCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker, Modal } from 'antd';
import api from '../../services/api'
import { displayMessage } from '../../services/helper';
import moment from 'moment';
import styles from '../../services/styles';
import { MultiSelect } from '../../components/selects/MultiSelect';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
const { bc9, bc10 } = styles

const maxRequesterForFilter = 10

// SVGs:
const FilterIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height} viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M8.69575 6.89938L13.9111 0.628129C14.006 0.514626 14.0265 0.355953 13.965 0.22106C13.9029 0.0861633 13.7699 0 13.6235 0H0.376485C0.230051 0 0.0970863 0.0861678 0.0350077 0.22106C-0.0264951 0.355956 -0.00599414 0.514625 0.0888961 0.628129L5.30425 6.89938C5.36341 6.96831 5.39504 7.05805 5.39269 7.15015V13.804C5.39094 13.8789 5.43252 13.9478 5.49871 13.9805C5.56548 14.0138 5.64456 14.0037 5.70138 13.9561L8.60723 11.5345V7.15015C8.60489 7.05804 8.63659 6.96831 8.69575 6.89938Z" 
            fill={fill}
        />
    </svg>
)
export default function ListControlFilters({isModalVisible, handleOnCloseModal, loadControlsData, handleScrollToFirstControl, currentFilters, setCurrentFilters}){
        const {mobile_mode} = useContext(GeneralContext)
        
        const [localFilters, setLocalFilters] = useState({})
        const [selectedDataButton, setSelectedDataButton] = useState([])

        const mountPatients = async e => {
            try {
                const { data } = await api.patient.listForSelectOptions({
                    search_string: e,
                    limit: maxRequesterForFilter,
                })
                return data
            } catch (error) {
                console.log(error)
            }
        }

        const handleOnSelectPatient = async e => {
            try {
                if (e == undefined) {
                    setLocalFilters({...localFilters, patients_selected:[]})
                    return
                }
                setLocalFilters({...localFilters, patients_selected: e})
            } catch (error) {
                console.log(error)
            }
        }

        useEffect(()=>{
            setLocalFilters({
                find: currentFilters?.find,
                patients_selected: currentFilters?.patients_selected
            })
            if (currentFilters?.days_group && currentFilters?.days_group.length > 0) {
                setSelectedDataButton(currentFilters?.days_group)
            }
        },[])


        const handleCommit = ()=>{
            handleScrollToFirstControl({is_auto: true})
            const updated_filters = {...currentFilters, ...localFilters, days_group: selectedDataButton}
            loadControlsData({...updated_filters},false, true)
            handleOnCloseModal()
        }

        return(
            <Modal
                title={<div style={{fontSize: 24, fontWeight: 'bold', display: 'flex', flex:1, alignItems: 'center', gap: '3px', color: bc9}}>
                    <FilterIcon width={24} height={24} fill={bc9} />
                    {displayMessage('FILTERS')}
                </div>}
                visible={isModalVisible}
                onCancel={() => handleOnCloseModal()}
                centered={true}
                footer={null}
                width={mobile_mode ? '90%' : 660}
                style={{ position: 'relative', borderRadius: '20px'}}
                bodyStyle={{ display: 'flex', flexDirection: 'column', gap: 10, borderRadius: '20px'}}
                className='affected-modal'
            >
                <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 10, paddingRight: 10, borderRadius: 20,alignItems: 'center', backgroundColor: bc10}}>
                    <div style={{ fontWeight: 'bold', color: bc9 }}> {displayMessage("PATIENT")}:</div>
                    <MultiSelect
                        mode="multiple"
                        allowClear
                        fetchOptions={async e => mountPatients(e)}
                        placeholder={displayMessage('PATIENTS') + ' . . .'}
                        onChange={handleOnSelectPatient}
                        value={localFilters?.patients_selected}
                    />

                </div>
                <div style={{display: 'flex', marginLeft: mobile_mode ? 0 : 10, marginRight: 10, alignItems: mobile_mode ? 'flex-start' : 'center', justifyContent: 'flex-start', flexDirection: mobile_mode ? 'column' : 'row', gap: mobile_mode ? 5 : 0}}>
                    <div style={{ fontWeight: 'bold', color: bc9 }}> {displayMessage("LAST")}</div>
                    <div style={{display: 'flex', flex: 1, justifyContent: mobile_mode ? 'flex-start':'space-evenly', flexWrap: 'wrap', gap: 5}}>
                        <Button
                            type='default'
                            style={{backgroundColor: selectedDataButton.includes(15) ? bc9 : 'white', color: selectedDataButton.includes(15) ? 'white': bc9, justifyItems: 'center', borderRadius: '20px' }}
                            onClick={()=>setSelectedDataButton([15])}
                        >
                            {displayMessage('DAY_15')}
                        </Button>
                        <Button
                            type='default'
                            style={{backgroundColor: selectedDataButton.includes(30) ? bc9 : 'white', color: selectedDataButton.includes(30) ? 'white': bc9, justifyItems: 'center', borderRadius: '20px' }}
                            onClick={()=>setSelectedDataButton([30])}
                        >
                            {displayMessage('DAY_30')}
                        </Button>
                        <Button
                            type='default'
                            style={{backgroundColor: selectedDataButton.includes(60) ? bc9 : 'white', color: selectedDataButton.includes(60) ? 'white': bc9, justifyItems: 'center', borderRadius: '20px' }}
                            onClick={()=>setSelectedDataButton([60])}
                        >
                            {displayMessage('DAY_60')}
                        </Button>
                        <Button
                            type='default'
                            style={{backgroundColor: selectedDataButton.includes(90) ? bc9 : 'white', color: selectedDataButton.includes(90) ? 'white': bc9, justifyItems: 'center', borderRadius: '20px' }}
                            onClick={()=>setSelectedDataButton([90])}
                        >
                            {displayMessage('DAY_90')}
                        </Button>
                        <Button
                            type='default'
                            shape="circle"
                            style={{
                                backgroundColor: selectedDataButton.length <= 0 ? bc9 : 'white', 
                                color: selectedDataButton.length <= 0 ? 'white': bc9,
                                padding: 0,
                                display:'flex', 
                                justifyContent: 'center', 
                                alignItems: 'end',
                                fontSize: 24
                            }}
                            onClick={()=>setSelectedDataButton([])}
                        >
                            <CloseCircleOutlined style={{height: 28}}/>
                        </Button>
                    </div>
                </div>
                {
                    selectedDataButton?.length <=0 &&
                    <div style={{display: 'flex', alignItems: mobile_mode ? 'flex-start' : 'center', justifyContent: 'space-between', flexDirection: mobile_mode ? 'column' : 'row', gap: mobile_mode ? 10 : 0}}>
                        <div style={{ display: 'flex',width: mobile_mode ? '100%' : 'auto' ,flexDirection: 'row', paddingLeft: 10, paddingRight: 10, borderRadius: 20,alignItems: 'center', backgroundColor: bc10}}>
                            <div style={{ fontWeight: 'bold', color: bc9 }}> {displayMessage("START_DATE")}:</div>
                            <DatePicker
                                allowClear
                                format="DD/MM/YYYY"
                                placeholder={displayMessage("SELECT_HERE")}
                                suffixIcon = {null}
                                prefix = {null} 
                                style={{maxWidth: '120px', backgroundColor: bc10}}
                                onChange={(date) => {
                                    setCurrentFilters({ 
                                        ...currentFilters, 
                                        start_date: date ? date.format("YYYY-MM-DD") : null
                                    })
                                }}
                                value={currentFilters?.start_date ? moment(currentFilters.start_date, "YYYY-MM-DD") : null}
                                disabledDate={(current) => {
                                    return current && current.isAfter(moment(currentFilters.end_date, "YYYY-MM-DD"), 'day');
                                }}
                            ></DatePicker>
                        </div>
                        <div style={{ display: 'flex',width: mobile_mode ? '100%' : 'auto' ,flexDirection: 'row', paddingLeft: 10, paddingRight: 10, borderRadius: 20,alignItems: 'center', backgroundColor: bc10}}>
                            <div style={{ fontWeight: 'bold', color: bc9}}> {displayMessage("END_DATE")}:</div>
                            <DatePicker
                                allowClear
                                format="DD/MM/YYYY"
                                placeholder={displayMessage("SELECT_HERE")}
                                suffixIcon = {null}
                                prefix = {null} 
                                style={{maxWidth: '120px', backgroundColor: bc10}}
                                onChange={(date) => {
                                    setCurrentFilters({ 
                                        ...currentFilters, 
                                        end_date: date ? date.format("YYYY-MM-DD") : null
                                    })
                                }}
                                value={currentFilters?.end_date ? moment(currentFilters.end_date, "YYYY-MM-DD") : null}
                                disabledDate={(current) => {
                                    return current && current.isBefore(moment(currentFilters.start_date, "YYYY-MM-DD"), 'day');
                                }}
                            ></DatePicker>
                        </div>
                    </div>
                }
                <div style={{display: 'flex', marginLeft: 10, marginRight: 10, alignItems: 'center', justifyContent: 'flex-end'}}>
                    <Button style={{backgroundColor: bc9, color: 'white', borderRadius: '20px'}} onClick={()=>handleCommit()}>{displayMessage("APPLY_FILTERS")}</Button>
                </div>
            </Modal>
        )
    }